/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyCommentFormContainer_story = {
    readonly id: string;
    readonly isClosed: boolean;
    readonly " $refType": "ReplyCommentFormContainer_story";
};
export type ReplyCommentFormContainer_story$data = ReplyCommentFormContainer_story;
export type ReplyCommentFormContainer_story$key = {
    readonly " $data"?: ReplyCommentFormContainer_story$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyCommentFormContainer_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyCommentFormContainer_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isClosed",
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '45a6c398909facd4912a61b08e6a2d2b';
export default node;
